import { useEffect, useState } from "react"
import { doc, onSnapshot } from "firebase/firestore"
import { db } from "@/lib/firebase"
import type { PortfolioItem } from "@/types/models"

export function useHealedDetail(healedId: string | undefined) {
  const [healed, setHealed] = useState<PortfolioItem | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<unknown>(null)

  useEffect(() => {
    if (!healedId) {
      setHealed(null)
      setLoading(false)
      return
    }

    setLoading(true)
    
    // Use onSnapshot for real-time updates
    const unsubscribe = onSnapshot(
      doc(db, "healedPortfolioItems", healedId),
      (healedDoc) => {
        if (healedDoc.exists()) {
          const data = healedDoc.data()
          const healedData: PortfolioItem = {
            id: healedDoc.id,
            artistId: data.artistId as string,
            type: (data.type as PortfolioItem["type"]) ?? "image",
            storagePath: (data.storagePath as string) ?? "",
            imageUrl: data.imageUrl as string,
            compressedImageUrl: data.compressedImageUrl as string | undefined,
            width: (data.width as number) ?? 0,
            height: (data.height as number) ?? 0,
            styleTags: (data.styleTags as string[]) ?? [],
            caption: (data.caption as string) ?? "",
            createdAt: data.createdAt?.toDate?.() ?? new Date(),
            isHealed: true,
          }
          setHealed(healedData)
          setError(null)
        } else {
          setError(new Error("Healed portfolio item not found"))
          setHealed(null)
        }
        setLoading(false)
      },
      (err) => {
        console.error("[useHealedDetail] Error fetching healed item:", err)
        setError(err)
        setLoading(false)
      }
    )

    return () => unsubscribe()
  }, [healedId])

  return { healed, loading, error }
}


